var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0)" } }, [
        _c("path", {
          attrs: {
            d: "M1.56413 13.1676C1.48461 12.5291 1.46702 11.8804 1.51254 11.2414C1.5567 10.6044 1.66258 9.97012 1.82858 9.35361C1.99459 8.7371 2.21866 8.13695 2.49836 7.56226C2.78023 6.98247 3.12036 6.43045 3.5052 5.92043C3.9007 5.39785 4.34859 4.91283 4.83587 4.48054C5.83439 3.59318 7.04564 2.89258 8.31489 2.47192C8.93579 2.26441 9.57881 2.11959 10.2267 2.03851C10.8608 1.96025 11.5079 1.94225 12.1535 1.98788C12.7895 2.0326 13.4253 2.13888 14.0412 2.30392C14.6572 2.46897 15.2609 2.69481 15.8335 2.97314C16.4144 3.25694 16.9668 3.59555 17.4754 3.97998C17.9974 4.37452 18.4824 4.82241 18.9152 5.31066C19.3593 5.81163 19.7567 6.36256 20.0957 6.94975C20.1033 6.96301 20.1193 6.96809 20.1326 6.96043L21.1592 6.36773C21.5166 6.16137 21.956 6.45245 21.9054 6.86205L21.4332 10.6841C21.3925 11.0136 21.0478 11.2127 20.742 11.0832L17.1959 9.58105C16.8159 9.42007 16.7835 8.894 17.141 8.68764L18.1656 8.09605C18.1789 8.0884 18.1844 8.07091 18.1768 8.05765C17.9125 7.59998 17.6033 7.17083 17.2583 6.78155C16.9213 6.40171 16.5456 6.05447 16.1395 5.74778C15.7444 5.44886 15.314 5.18433 14.8626 4.96523C14.4172 4.74775 13.9481 4.5734 13.4678 4.44389C12.9875 4.31438 12.4937 4.23234 12.0002 4.19744C11.4987 4.16202 10.9938 4.17595 10.5006 4.23682C9.99747 4.29829 9.4975 4.41168 9.01478 4.57269C8.02833 4.90043 7.08381 5.44703 6.30621 6.13648C5.92829 6.47237 5.57914 6.84922 5.27244 7.25528C4.97257 7.65101 4.70954 8.08175 4.48933 8.53127C4.27337 8.97705 4.0971 9.44726 3.96855 9.92701C3.83945 10.4058 3.75741 10.8996 3.72265 11.3956C3.68693 11.8921 3.70031 12.3961 3.76244 12.8937C3.82265 13.3924 3.93645 13.8909 4.0972 14.3776C4.26349 14.8739 4.48056 15.3562 4.74424 15.8129C5.00792 16.2696 5.3171 16.6988 5.66155 17.0871C6.00379 17.4716 6.37856 17.8194 6.7809 18.1218C7.18021 18.4235 7.60943 18.6861 8.05936 18.9048C8.50474 19.1223 8.97343 19.2981 9.45263 19.4257C9.93238 19.5543 10.4277 19.6367 10.9203 19.6722C11.4212 19.7066 11.9248 19.6948 12.4189 19.6333C12.9239 19.5708 13.4239 19.4574 13.9047 19.2975C14.8896 18.9693 15.8343 18.4252 16.6133 17.7337C16.9931 17.3967 17.3403 17.0209 17.647 16.6149C17.946 16.2197 18.2105 15.7894 18.4296 15.3379C18.5743 15.0415 18.7 14.7345 18.806 14.4208C18.8943 14.1595 19.1667 14.001 19.4331 14.0724L20.6085 14.3873C20.875 14.4587 21.0345 14.733 20.95 14.9956C20.8053 15.4454 20.6282 15.885 20.4217 16.3089C20.1388 16.8892 19.7993 17.4422 19.4148 17.9507C19.0203 18.4727 18.5724 18.9577 18.0842 19.3906C17.5841 19.8341 17.0332 20.2315 16.446 20.5705C15.8588 20.9095 15.2383 21.1885 14.6051 21.3992C13.9862 21.6056 13.3427 21.7519 12.6934 21.8326C12.0583 21.9114 11.4096 21.929 10.7641 21.8834C10.129 21.8381 9.49574 21.7317 8.87978 21.5666C8.26382 21.4016 7.66161 21.1762 7.08898 20.8978C6.51126 20.6173 5.95829 20.2777 5.44564 19.8906C4.92886 19.5007 4.44439 19.0538 4.00464 18.558C3.56061 18.057 3.16322 17.5061 2.82531 16.9208C2.4874 16.3355 2.20898 15.7159 1.99603 15.079C1.78766 14.4522 1.64284 13.8091 1.56413 13.1676Z",
            fill: "currentColor",
          },
        }),
        _c("path", {
          attrs: {
            d: "M11 8V13.25L14 15",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0" } }, [
          _c("rect", {
            attrs: {
              width: "24",
              height: "24",
              fill: "white",
              transform: "matrix(-1 0 0 1 24 0)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }